// CourseStoreOptions.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"; // Кастомный спиннер


import Header from '../../components/Headers/Header';
import './CourseOptions.css';

import BoostRobotOptions from './BoostRobotOptions.png';
import coursesStore from "../../store/CourseStore";
import { CourseOptionsToggle } from "./components";
import { InBasketButton } from "../../components/InBasketButton";
import { observer } from "mobx-react-lite";
import { useCart } from "../../store/CartContext";
import { Context } from "../../index";
import CartBtn from "../../components/CartBtn/CartBtn";

// const tariffOptions = ['годовой тариф', 'тариф на 1 месяц']
const tariffOptions = ['тариф на 1 месяц']
const mentorOptions = ['с наставником + ИИ', 'ИИ, без наставника']

const MENTOR_ID_OPTION = '673c6faf2fcf8fdbc6b4320f'

const CourseOptions = observer(() => {
    const navigate = useNavigate();
    const { id } = useParams();

    const { user, } = useContext(Context);

    const userId = user?.user.id

    const [selectedMentor, setSelectedMentor] = useState(mentorOptions[0]);
    const [selectedTariff, setSelectedTariff] = useState(tariffOptions[0]);

    const [currentSum, setCurrentSum] = useState(null)

    const [course, setCourse] = useState(null);

    const { addItem } = useCart();

    const allCourses = coursesStore.data

    const handleChangeTariff = (option) => {
        if (course === null || currentSum === null || selectedTariff === option) return

        const coursePrice = course.price

        setSelectedTariff(option)
        setCurrentSum(prevSum => option === tariffOptions[0] ? prevSum + coursePrice * 11 : prevSum - coursePrice * 11)
    }

    const handleChangeMentor = (option) => {
        if (course === null || currentSum === null || selectedMentor === option) return

        setSelectedMentor(option)

        setCurrentSum(prevSum => option === mentorOptions[0] ? prevSum + 700 : prevSum - 700)
    }

    useEffect(() => {
        if (allCourses !== null) return
        coursesStore.fetchAllCoursesData();
    }, []);


    useEffect(() => {
        if (id === undefined || id === null || allCourses === null) return

        const foundCourse = allCourses.find(({ id: courseId }) => courseId === id) ?? null
        setCourse(foundCourse ?? null)
        setCurrentSum(foundCourse?.price + 700 ?? null)
    }, [id, allCourses]);


    const handleInBasketClick = () => {
        if (userId === undefined || course === null) return

        addItem({
            course_id: course.id,
            // months: selectedTariff === tariffOptions[0] ? 12 : 1,
            months: 1,
            option_ids: selectedMentor === mentorOptions[0] ? [MENTOR_ID_OPTION] : [],
            student_id: userId
        });

        navigate('/courses-cart');
    };

    if (!course) return <LoadingSpinner />; {/* Заменяем стандартную загрузку на кастомную */ };

    return (
        <div className='VideoCard flex flex-col p h-100 scrollbar-none'>
            <Header />

            <div class='flex justify-center break-p-1020:justify-between mt-[50px] mt-sm-[101px] flex-grow'>
                <div className='flex flex-col gap-[36px] flex-grow'>
                    <div className='text-sub-title dark:text-white text-[24px] sm:text-[32px] font-semibold'>
                        Выбери, как{' '}<span className='text-lavender'>ты</span>{' '}хочешь учиться
                    </div>

                    <div className='flex flex-col gap-[56px] mb-6 mb-sm-[81px]'>
                        <CourseOptionsToggle
                            grayTitle='По'
                            lavenderTitle='времени:'
                            options={tariffOptions}
                            icon={<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.6364 14.0193C30.6364 17.5754 27.6381 20.7498 24 20.7498C20.3619 20.7498 17.3636 17.5754 17.3636 14.0193C17.3636 10.4154 20.4073 7 24 7C27.5927 7 30.6364 10.4154 30.6364 14.0193ZM41 33.5558C41 35.4181 39.9393 37.2344 37.2423 38.6402C34.5123 40.0632 30.1951 41.0003 24 41.0003C17.8049 41.0003 13.4877 40.0632 10.7577 38.6402C8.06067 37.2344 7 35.4181 7 33.5558C7 31.8404 8.52038 29.9801 11.6968 28.4899C14.7938 27.037 19.1425 26.1112 24 26.1112C28.8575 26.1112 33.2062 27.037 36.3032 28.4899C39.4796 29.9801 41 31.8404 41 33.5558Z" stroke-width="2" />
                            </svg>
                            }
                            currentOption={selectedTariff}
                            setOption={handleChangeTariff}
                        />

                        <CourseOptionsToggle
                            grayTitle='Кто будет твоим'
                            lavenderTitle='помощником:'
                            options={mentorOptions}
                            icon={<svg width="44" height="42" viewBox="0 0 44 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M34.895 33.5079L34.3866 32.6468L34.895 33.5079ZM35.8781 31.7857H34.8781H35.8781ZM19.9314 39.8072L19.3949 40.6511L19.9314 39.8072ZM24.1111 39.8758L24.6195 40.7369L24.1111 39.8758ZM1.80838 13.2737L1.29646 12.4147H1.29645L1.80838 13.2737ZM1.80838 14.9918L1.29646 15.8508H1.29646L1.80838 14.9918ZM23.0241 26.4147L23.536 27.2737L23.0241 26.4147ZM20.9763 26.4147L21.4883 25.5557L20.9763 26.4147ZM42.192 13.2737L42.7039 12.4147L42.192 13.2737ZM42.192 14.9918L41.6801 14.1328L42.192 14.9918ZM10.0354 33.5167L10.5718 32.6728L10.0354 33.5167ZM23.0241 1.85079L22.5121 2.70982L23.0241 1.85079ZM20.9763 1.85079L21.4883 2.70982L20.9763 1.85079ZM43.4002 14.0995C43.4002 13.5472 42.9525 13.0995 42.4002 13.0995C41.8479 13.0995 41.4002 13.5472 41.4002 14.0995H43.4002ZM41.4002 24.8995C41.4002 25.4518 41.8479 25.8995 42.4002 25.8995C42.9525 25.8995 43.4002 25.4518 43.4002 24.8995H41.4002ZM22.5121 2.70982L41.6801 14.1328L42.7039 12.4147L23.536 0.991764L22.5121 2.70982ZM41.6801 14.1328L22.5121 25.5557L23.536 27.2737L42.7039 15.8508L41.6801 14.1328ZM2.32031 14.1328L21.4883 2.70982L20.4644 0.991763L1.29646 12.4147L2.32031 14.1328ZM21.4883 25.5557L9.62019 18.483L8.59633 20.2011L20.4644 27.2737L21.4883 25.5557ZM9.62019 18.483L2.32031 14.1328L1.29646 15.8508L8.59633 20.2011L9.62019 18.483ZM8.10826 19.3421V31.8288H10.1083V19.3421H8.10826ZM9.49891 34.3606L19.3949 40.6511L20.4678 38.9632L10.5718 32.6728L9.49891 34.3606ZM24.6195 40.7369L35.4035 34.369L34.3866 32.6468L23.6026 39.0147L24.6195 40.7369ZM36.8781 31.7857L36.8781 19.3421H34.8781L34.8781 31.7857H36.8781ZM35.4035 34.369C36.3173 33.8293 36.8781 32.847 36.8781 31.7857H34.8781C34.8781 32.1395 34.6912 32.4669 34.3866 32.6468L35.4035 34.369ZM19.3949 40.6511C20.9818 41.6598 23.0004 41.6929 24.6195 40.7369L23.6026 39.0147C22.6311 39.5883 21.42 39.5685 20.4678 38.9632L19.3949 40.6511ZM1.29645 12.4147C-0.00507188 13.1903 -0.00506544 15.0752 1.29646 15.8508L2.32031 14.1328L2.32031 14.1328L1.29645 12.4147ZM22.5121 25.5557C22.1967 25.7436 21.8037 25.7436 21.4883 25.5557L20.4644 27.2737C21.4106 27.8376 22.5898 27.8376 23.536 27.2737L22.5121 25.5557ZM41.6801 14.1328V14.1328L42.7039 15.8508C44.0055 15.0752 44.0055 13.1903 42.7039 12.4147L41.6801 14.1328ZM8.10826 31.8288C8.10826 32.8551 8.63283 33.8101 9.49891 34.3606L10.5718 32.6728C10.2831 32.4893 10.1083 32.1709 10.1083 31.8288H8.10826ZM23.536 0.991764C22.5898 0.427877 21.4106 0.427875 20.4644 0.991763L21.4883 2.70982C21.8037 2.52186 22.1967 2.52186 22.5121 2.70982L23.536 0.991764ZM41.4002 14.0995V24.8995H43.4002V14.0995H41.4002Z" fill="#595959" />
                            </svg>
                            }
                            currentOption={selectedMentor}
                            setOption={handleChangeMentor}
                        />
                    </div>

                    {currentSum !== null &&
                        <div class='flex flex-col break-p-800:flex-row  break-p-800:gap-[75px] gap-[13px] items-center mt-auto break-p-800:mt-0 break-p-800:mb-0 mb-[28px] break-p-800:pb-0 pb-[30px]' >
                            <div class='text-[32px] font-semibold text-light-gray self-start break-p-800:self-auto text-nowrap dark:text-white max-w-[250px] overflow-visible'>
                                Итого: <span class='text-sub-title dark:text-lavender '>{currentSum?.toLocaleString('ru-RU')} ₽</span>
                            </div>

                            <div>
                                <InBasketButton
                                    onClick={handleInBasketClick}
                                />
                            </div>
                        </div>}
                </div>

                <div class='break-p-1200:block hidden'>
                    <img src={BoostRobotOptions} alt="BoostRobot" />
                </div>
            </div>

            <CartBtn />
        </div>
    );
});

export default CourseOptions;
